import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@shared/services/userpermissions.service';
import { sidebarItems } from '../admin/menu';

/**
 * Redirects the bare `/administration` entry to the first admin sidebar item the current user has permission for. The Administration menu button lands here (rather than a hardcoded child) so that an admin who lacks the previous default's permission (`iam:OrganizationsAccountsPut`) — e.g. a SCIM-only or
 * sync-monitoring-only user — reaches a page they can actually open instead of being bounced to `/core` by that child's PermissionGuard.
 *
 * Only acts on the exact `/administration` path; navigations to a specific child pass through untouched so each child's own PermissionGuard still applies.
 */
export const AdminLandingGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
	const url = state.url.split('?')[0].replace(/\/$/, '');
	if (url !== '/administration') {
		return true;
	}

	const userPermissions = inject(UserPermissionsService);
	const router = inject(Router);

	const firstAllowed = sidebarItems.find((item) => {
		const permissions = (Array.isArray(item.permission) ? item.permission : item.permission ? [item.permission] : []).filter((p) => p !== '');
		return permissions.length === 0 || userPermissions.hasPermissions(permissions);
	});
	if (firstAllowed) {
		return router.parseUrl(`/${firstAllowed.path}`);
	}

	sessionStorage.setItem('Link.Illegal', 'x');
	return router.parseUrl('/core');
};
